module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-updates widget panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showBadge) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n            " + _vm._s(_vm.badgeStr) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("\n            Forum Replies\n            "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Replies to forum threads you are apart of.'),
      expression: "'Replies to forum threads you are apart of.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [_c('scroll-area', {
    ref: "scrollbar",
    attrs: {
      "wheelPropagationEnabled": false
    }
  }, [(!_vm.isFetching && !_vm.error && _vm.notifications.length > 0) ? _c('ul', _vm._l((_vm.notifications), function(notif) {
    return _c('li', [_c('div', {
      staticClass: "post-thread"
    }, [_c('router-link', {
      attrs: {
        "title": notif.thread.title,
        "to": _vm.getThreadUrl(notif.thread)
      }
    }, [_vm._v("\n                            " + _vm._s(notif.thread.title) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "post-date"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("shortDate")(notif.post.createdAt)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('ForumAvatar', {
      attrs: {
        "src": notif.post.author.avatarUrl
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "author-name",
      attrs: {
        "to": _vm.getAuthorUrl(notif.post.author)
      }
    }, [_vm._v("\n                            " + _vm._s(notif.post.author.name) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "post-content"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getPostUrl(notif.thread, notif.post)
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("truncate")(_vm._f("stripTags")(notif.post.content), 50)) + "\n                        ")])], 1)])
  })) : _vm._e(), _vm._v(" "), (!_vm.isFetching && !_vm.error && _vm.notifications.length === 0) ? _c('p', {
    staticClass: "empty-msg"
  }, [_vm._v("\n                No replies to your threads or posts.\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.error) ? _c('p', {
    staticClass: "empty-msg"
  }, [_vm._v("\n                Failed to fetch replies.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isFetching) ? _c('Loader') : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73e7451a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ForumUpdates.vue
// module id = 2050
// module chunks = 2